import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-zapier',
  templateUrl: './zapier.component.html',
  styleUrls: ['./zapier.component.scss']
})
export class ZapierComponent implements OnInit {
  img1$: any = null;
  img2$: any = null;
  img3$: any = null;
  img4$: any = null;
  img5$: any = null;
  img6$: any = null;
  img7$: any = null;
  img8$: any = null;
  img9$: any = null;
  img10$: any = null;
  img11$: any = null;
  img12$: any = null;
  img13$: any = null;
  img14$: any = null;
  img15$: any = null;
  img16$: any = null;
  img17$: any = null;

  constructor(
    private dialogRef: MatDialogRef<ZapierComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.img1$ = this.getBase64('assets/imagenes/campania/1.jpg');
    this.img2$ = this.getBase64('assets/imagenes/campania/2.jpg');
    this.img3$ = this.getBase64('assets/imagenes/campania/3.jpg');
    this.img4$ = this.getBase64('assets/imagenes/campania/4.jpg');
    this.img5$ = this.getBase64('assets/imagenes/campania/5.jpg');
    this.img6$ = this.getBase64('assets/imagenes/campania/6.jpg');
    this.img7$ = this.getBase64('assets/imagenes/campania/7.jpg');
    this.img8$ = this.getBase64('assets/imagenes/campania/8.jpg');
    this.img9$ = this.getBase64('assets/imagenes/campania/9.jpg');
    this.img10$ = this.getBase64('assets/imagenes/campania/10.jpg');
    this.img11$ = this.getBase64('assets/imagenes/campania/11.jpg');
    this.img12$ = this.getBase64('assets/imagenes/campania/12.jpg');
    this.img13$ = this.getBase64('assets/imagenes/campania/13.jpg');
    this.img14$ = this.getBase64('assets/imagenes/campania/14.jpg');
    this.img15$ = this.getBase64('assets/imagenes/campania/15.jpg');
    this.img16$ = this.getBase64('assets/imagenes/campania/16.jpg');
    this.img17$ = this.getBase64('assets/imagenes/campania/17.jpg');
  }

  onNoClick() {
    this.dialogRef.close();
  }

  getBase64(url: string) {
    return new Promise((resolve, reject) => {
      let xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onload = function () {
        let reader: FileReader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        }
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    });
  }
}